<template>
  <div class="section">
    <div class="container">
      <div class="columns is-flex-direction-column">
        <div
          id="sign-up-email"
          class="column is-half-desktop is-offset-one-quarter-desktop"
        >
          <h1 class="subtitle">会員登録</h1>
          <UserRegistrationFlow
            :isAuthCompleted="isAuthCompleted"
          />
        </div>
        <div class="created mt-2">
          <p class="is-size-7 has-text-centered">
            既にアカウントをお持ちの方は
            <router-link to="/signin">こちら</router-link>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import UserRegistrationFlow from '@/components/Organisms/UserRegistrationFlow';

// TODO: FacebookやGoogleでサインアップできるように
export default {
  name: 'SignUp',
  components: {
    UserRegistrationFlow
  },
  props: {
    isAuthCompleted: Boolean,
  },
};
</script>

<style lang="scss" scoped></style>
